import axios from "axios";
import BB from "bluebird";

/**
 * ConfigService
 *
 * Service used for obtaining lists of sections, items, etc for filling dropdowns.
 *
 *
 */

export default {
	listContentAreas() {
		return axios.get("/v3/content_areas");
	},

	listGrades() {
		return axios.get("/v3/grades");
	},

	listAssessments() {
		return axios.get("/v3/assessments");
	},

	listTeams() {
		return axios.get("/v3/admin/teams");
	},

	getItem(id) {
		return axios.get(`/v3/item/${id}`);
	},

	getStandards() {
		return axios.get(`/v3/standards`);
	},
	getEssentialSkills() {
		return axios.get(`/v3/all_essential_skills`);
	},
	getAssessmentPurpose() {
		return axios.get(`/v3/all_assessment_purposes`);
	},

	getPublicGrades(refID){
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_grades/${refID}`,config);
	},
	getPublicEssentialSkills(refID){
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_essential_skills/${refID}`,config);
	},
	getPublicStandards(refID){
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_standards/${refID}`,config);
	},
	getPublicContentAreas(refID){
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_content_areas/${refID}`,config);
	}
};



// WEBPACK FOOTER //
// ./src/services/ConfigService.js